import React, { useState, useContext } from 'react'
import { auth, db } from './firebase'
import { useHistory } from 'react-router-dom'

import { LoginContext } from "./Contexts/LoginContext";


export default function Home() {
    const { currentUser } = auth
    const [showModal, setShowModal] = useState(false)
    
    const { setMemberPiece } = useContext(LoginContext);

    const history = useHistory()
    const newGameOptions = [
        { label: 'Black pieces', value: 'b' },
        { label: 'White pieces', value: 'w' },
        { label: 'Random', value: 'r' },
    ]

    function handlePlayOnline() {
        setShowModal(true)
    }

    async function startOnlineGame(startingPiece) {
        const member = {
            uid: currentUser.uid,
            piece: startingPiece === 'r' ? ['b', 'w'][Math.round(Math.random())] : startingPiece,
            name: localStorage.getItem('userName'),
            creator: true
        }

        setMemberPiece(member.piece)  
        
        const game = {
            status: 'waiting',
            members: [member],
            gameId: `${Math.random().toString(36).substr(2, 9)}_${Date.now()}`
        }
        await db.collection('games').doc(game.gameId).set(game)
        history.push(`/game/${game.gameId}`)
    }


    return (
        <>
            <div className="columns home">
                <div className="column has-background-link home">
                  <div className="horizontal-text-instructions">
                    Multiplayer chess dapp instructions:
                  </div>
                  <div className="horizontal-text-instructions">
                    1) This game allows you and your opponent to bet 0.1 test ETH against each other. Please use only a browser which has the metamask extension installed!
                  </div>
                  <div className="horizontal-text-instructions">
                    2) Please ensure that you are connected to the Ropsten Test Network on metamask. Test ETH can be obtained for free from the Ropsten faucets.
                  </div>
                  <div className="horizontal-text-instructions">
                    3) If you are the first player, click on start game, select your colour/piece, then share your unique game link generated with your friend.  
                  </div>
                  <div className="horizontal-text-instructions">
                    4) If you are the second player, copy the unique game link that your friend has shared, and paste it into your browser. You will then enter a match against your friend.
                  </div>
                  <div className="horizontal-text-instructions">
                    5) Moves can be made only after both players have connected to metamask and staked 0.1 test ETH.
                    To do so, click "Connect" on the top panel, then click on "Stake 0.1 ETH", then wait for your 0.1 test ETH transaction to be completed.
                  </div>
                  <div className="horizontal-text-instructions">
                    6) If a stalemate happens, both players will be able to claim back their stake of 0.1 test ETH. Do remember to claim back your stake before exiting or starting a new game!
                    To do so, click "Register stalemate" and wait for the transaction to be completed, then click "Claim back 0.1 ETH".
                  </div>
                  <div className="horizontal-text-instructions">
                    7) If you win the game, you will be able to claim 0.2 test ETH (earning for yourself 0.1 test ETH in the process!) Do remember to claim your winnings before exiting or starting a new game!
                    To do so, click "Register win" and wait for the transaction to be completed, then click "Claim 0.2 ETH winnings".
                  </div>
                  <div className="horizontal-text-instructions">
                    WARNING: Please DO NOT refresh the page while the game is in progress, or you might lose your ability to claim back your test ETH!
                  </div>
                    <button className="button is-primary"
                        onClick={handlePlayOnline}>
                        Start Game
                    </button>
                </div>
            </div>
            <div className={`modal ${showModal ? 'is-active' : ''}`}>
                <div className="modal-background"></div>
                <div className="modal-content">
                    <div className="card">
                        <div className="card-content">
                            <div className="content">
                                Please Select the piece you want to start
                            </div>

                        </div>
                        <footer className="card-footer">
                            {newGameOptions.map(({ label, value }) => (
                                <span className="card-footer-item pointer" key={value}
                                    onClick={() => startOnlineGame(value)}>
                                    {label}
                                </span>
                            ))}
                        </footer>
                    </div>
                </div>
                <button className="modal-close is-large" onClick={() => setShowModal(false)}></button>
            </div>
        </>
    )
}
